import React, { useMemo } from "react";
import Carousel from "react-multi-carousel";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardText, CardTitle } from "reactstrap";
import PropTypes from "prop-types";

import { energyCalculator, waysToSaveMonet } from "Routes/constants";
import { useMediaQuery } from "@mui/material";

import secondCardImage from "assets/images/working-environment.png";
import thirdCardImage from "assets/images/tax-invoice-paper.png";
import { ReactComponent as LeftArrow } from "assets/images/svg/leftarrow.svg";
import { ReactComponent as BankIcon } from "assets/images/svg/pigibankicon.svg";

import { getImageUrl } from "utils";

import "react-multi-carousel/lib/styles.css";

const CarouselSection = ({ offerSlider }) => {
  const navigate = useNavigate();
  const isArrowRequired = useMediaQuery("(max-width: 768px)");

  const responsive = useMemo(
    () => ({
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 2,
      },
      tablet: {
        breakpoint: { max: 991, min: 768 },
        items: 2,
      },
      mobile: {
        breakpoint: { max: 767, min: 320 },
        items: 1,
      },
    }),
    [offerSlider]
  );

  const cardsData = useMemo(
    () => [
      {
        cardImage: secondCardImage,
        cardHeader: "Energy Calculator",
        cardText:
          "Check your energy consumption with the help of the below given form.",
        onClick: () => navigate(energyCalculator),
      },
      {
        cardImage: thirdCardImage,
        cardHeader: "Tariff  Details",
        cardText:
          "Our focus is always on providing world class services and the most competitive electricity tariff",
        onClick: () =>
          window.open(
            getImageUrl(
              "MenuDocument\\b22d51ad-fae2-4bc7-90c2-39d86e7ccd53_GIFT PCL Tariff Schedule for FY 2024-25.pdf"
            ),
            "_blank"
          ),
      },
    ],
    []
  );

  const moneySavingCardsData = useMemo(
    () => [
      {
        cardImage: <BankIcon style={{ width: 85, height: 85 }} />,
        cardHeader: "Simple ways ",
        cardText:
          "Simplest Tips & Tricks to Bring Down Your Energy Consumption & Bill",
        onClick: () => navigate(waysToSaveMonet),
      },
      {
        cardImage: <BankIcon style={{ width: 85, height: 85 }} />,
        cardHeader: "Energy Calculator",
        cardText:
          "Give us a Little Information & We Shall Calculate Your Energy Requirement",
        onClick: () => navigate(energyCalculator),
      },
    ],
    []
  );

  return (
    <div>
      <Carousel
        responsive={responsive}
        arrows={isArrowRequired && !offerSlider}
        swipeable={true}
        draggable={true}
        showDots={isArrowRequired}
        infinite={true}
        partialVisible={false}
        dotListClass="custom-dot-list-style"
      >
        {!offerSlider
          ? cardsData.map((item, index) => {
              return (
                <div className="card-main-wrapper" key={index}>
                  <Card className="card-img-wrapper">
                    <CardBody
                      style={{
                        background: `url(${item.cardImage}) no-repeat`,
                        backgroundSize: "cover",
                      }}
                      className="card-img"
                    >
                      <CardTitle className="card-number-wrapper">
                        {(index + 1).toString().padStart(2, "0")}
                      </CardTitle>
                    </CardBody>
                  </Card>
                  <Card className="card-info-wrapper">
                    <CardBody className="card-text-wrapper">
                      <CardTitle tag="h2" className="medium-font">
                        {item.cardHeader}
                      </CardTitle>
                      <CardText className="regular-font">
                        {item.cardText}
                      </CardText>
                      <Button
                        className="viewmore-btn medium--dark gap-2"
                        onClick={() => (item.onClick ? item.onClick() : {})}
                      >
                        View More
                        <LeftArrow />
                      </Button>
                    </CardBody>
                  </Card>
                </div>
              );
            })
          : moneySavingCardsData.map((item, index) => {
              return (
                <Card key={index} className="saving-tips-card-wrapper">
                  <div className="saving-tips-img">{item.cardImage}</div>
                  <CardBody>
                    <CardTitle tag="h5" className="medium-font card-title">
                      <span className="card-number semibold-font pe-2">
                        {(index + 1).toString().padStart(2, "0")}
                      </span>
                      {item.cardHeader}
                    </CardTitle>
                    <CardText className="regular-font text-center">
                      {item.cardText}
                    </CardText>
                    <Button
                      className="card-btn medium-font"
                      style={{ margin: "0 auto" }}
                      onClick={() => (item.onClick ? item.onClick() : {})}
                    >
                      Know More
                      <LeftArrow />
                    </Button>
                  </CardBody>
                </Card>
              );
            })}
      </Carousel>
    </div>
  );
};

CarouselSection.propTypes = {
  offerSlider: PropTypes.bool,
};

export default CarouselSection;
